import BaseApi from "../../BaseApi";
import {headers} from "../../ApiSettings";

class Payment extends BaseApi {
    constructor() {
        super({ suffix: "" });
    }
    GetSalePeriod(params) {
        return this.httpService.get("/Accounting/period/active", {headers, params})
    }
    GetSaleUsingTime(params) {
        return this.httpService.get("/Accounting/sale/default-count-period", {headers, params})
    }
    GetSaleDefault(params) {
        return this.httpService.get("/Accounting/sale/default-panel", {headers, params})
    }
    postSaleCalculate(data) {
        return this.httpService.post("/Accounting/sale/calculate",data ,{headers})
    }
    postTypePayment(data) {
        return this.httpService.post("/Accounting/sale/final",data ,{headers})
    }
    postCountCalculate(data) {
        return this.httpService.post("/Accounting/upgrade/calculate",data ,{headers})
    }
    postIncreaseUser(data) {
        return this.httpService.post("/Accounting/upgrade/final",data ,{headers})
    }
    GetRemainTime(params) {
        return this.httpService.get("/Accounting/info", {headers, params})
    }
    postExtensionPeriodCalculate(data) {
        return this.httpService.post("/Accounting/extension/calculate",data ,{headers})
    }

    postExtensionPeriodFinal(data) {
        return this.httpService.post("/Accounting/extension/final",data ,{headers})
    }

    GetChargeCredit(params) {
        return this.httpService.get("/Accounting/DefaultCharge", {headers, params})
    }

    postChargeCredit(data) {
        return this.httpService.post("/Accounting/charge-credit/generate-link",data ,{headers})
    }
    GetPaymentInfo(params) {
        return this.httpService.get("/Accounting/payment/info", {headers, params})
    }
    GetRefreshToken(params) {
        return this.httpService.get("/Accounts/get-token-with-refresh-token", {headers, params})
    }
    GetHistory(params) {
        return this.httpService.get("/Accounting/History", {headers, params})
    }
    GetHistoryDetails(params) {
        return this.httpService.get("/Accounting/History/detail", {headers, params})
    }
}
const PaymentService = new Payment();
export default PaymentService;
